import React from "react";
import shortenString from "../helpers/shortenString";
import getDuration from "../helpers/formatEpisodeDuration";
import { PauseIcon, PlayIcon } from "@heroicons/react/16/solid";

export default function EpisodesNew({ episodes, isDark, playEpisode, activeEpisode, handlePause, playing, themeColor, headingFont }) {

    const bgColor = () => isDark ? " bg-[#252528] " : " bg-gray-100 "
    const divider = () => isDark ? " bg-[#6C6F74] " : " bg-gray-200 "
    const textColorLight = () => isDark ? " text-gray-400 " : " text-gray-600 "
    const darkAlternativeBgEven = () => isDark ? " bg-[#1F1F21] " : " bg-[#F6F7F8] "
    const darkAlternativeBgOdd = () => isDark ? " bg-transparent " : " bg-white "

    const textColor = () => isDark ? "#e5e7eb" : "black"
    const textColorBlue = () => themeColor ? themeColor : isDark ? "#736AFF" : "#4F46E5"

    const listItem = (episode, index) => {

        let activeId = activeEpisode.link.split("/").filter(Boolean).pop()
        let episodeId = episode.link.split("/").filter(Boolean).pop()
        return <div className={index % 2 == 0 ? darkAlternativeBgEven() : darkAlternativeBgOdd()}>
            <div className="flex flex-row justify-between px-4 items-center">
                <div key={episodeId} className='text-xs justify-start items-center w-full flex flex-row py-4 cursor-pointer'>
                    <div className="relative">
                        <div className="absolute bg-black opacity-10 w-full h-full rounded-md"></div>
                        {activeId === episodeId && playing ?
                            <div className="absolute" onClick={handlePause} style={{ top: "10px", left: "10px" }} >
                                <PauseIcon className="w-5 h-5" color='white' />
                            </div> :
                            <div className="absolute" onClick={() => playEpisode(episode)} style={{ top: "10px", left: "10px" }}>
                                <PlayIcon className="w-5 h-5" color='white' />
                            </div>}
                        <img alt={episode.title} className='h-10 w-10 rounded-md' src={episode.itunes.image} onClick={() => playEpisode(episode)} />
                    </div>
                    <div className="flex flex-9 flex-col w-full px-4" onClick={() => playEpisode(episode)}>
                        <div className={'text-sm mb-[2px] ' + (activeId === episodeId ? 'font-semibold ' : 'font-medium ')} style={activeId === episodeId ? { color: textColorBlue(), fontFamily: headingFont } : { color: textColor(), fontFamily: headingFont }}>{shortenString(episode.title)}</div>
                        <div className={'text-xs' + textColorLight()}>{episode.pubDate.slice(4, 16)}</div>
                    </div>
                </div>
                <div className={"text-md " + textColorLight()}> {getDuration(episode)}</div>
            </div>
            <div className={'h-[0.06rem] w-full' + divider()}>
            </div>
        </div>
    }

    return (
        <div className={bgColor()} style={{ overflowY: "scroll", height: "12rem" }}>
            {episodes.map((episode, index) => {
                return listItem(episode, index)
            })}
            <div style={{ margin: "50px" }}>
            </div>
        </div>
    )
}